/** Applied to all exterior/interior guide overlays in the camera frame. */
export const GUIDE_DISPLAY_BOOST = 1.25;

export interface PhotoCarGuide {
  id: string;
  imageSrc: string;
  /** Key under listingPost.images.photoSession.{exterior|interior}Guides */
  labelKey: string;
  /** CSS scale on top of container fit. */
  scale?: number;
  /** Container width as % of camera area (default 90). */
  widthPct?: number;
  /** Max height as % of camera area (default 76). */
  maxHeightPct?: number;
  /** When "video", shutter records ~maxVideoSeconds instead of a still. */
  captureMode?: "photo" | "video";
  /** Max recording length in seconds (engine video default 10). */
  maxVideoSeconds?: number;
}
